import { useEffect } from 'react';

/**
 * Global IntersectionObserver: any element with [data-reveal] gets an
 * .is-visible class added when it enters the viewport, triggering the
 * CSS fade/slide animation defined in App.css.
 *
 * Also toggles a .header-glass class on <header> when the page is scrolled
 * past 40px, for a frosted-glass effect on sticky header.
 */
export default function useScrollFx() {
  useEffect(() => {
    // 1. Scroll reveal
    const els = document.querySelectorAll('[data-reveal]');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.05 },
    );
    els.forEach((el) => obs.observe(el));

    // 2. Header glass on scroll
    const header = document.querySelector('header');
    const onScroll = () => {
      if (!header) return;
      if (window.scrollY > 40) header.classList.add('header-glass');
      else header.classList.remove('header-glass');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      obs.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  });
}
